import React from 'react';
import FormSection from 'components/forms/components/form-section';
import SponsorFormSection from 'components/forms/vendor-request/sponsor-form-section';
import VendorFormSection from 'components/forms/vendor-request/vendor-form-section';
import AddAttachmentsSection from 'components/forms/vendor-request/add-attachments-section';
import shortid from 'shortid';
import hasPermission from 'utils/hasPermission';
import permissions from 'utils/permissions';
import { NonIdealState } from '@blueprintjs/core';

const VendorRequestForm = props => (
  <div>
    <FormSection
      title="Sponsor Information"
      stepIcon="1"
      description={descriptionSponsor}
      inputs={<SponsorFormSection {...props} />}
    />
    <FormSection
      title="Third Party Information"
      stepIcon="2"
      description={description3rdParty}
      inputs={<VendorFormSection {...props} />}
    />
    <FormSection
      title="Add Document"
      stepIcon="3"
      description={descriptionDocuments}
      inputs={
        !hasPermission(props.appUser.permissions, [
          permissions.UPLOAD_REQUEST_ATTACHMENT,
          permissions.UPLOAD_ALL_REQUEST_ATTACHMENT,
        ]) ? (
          <NonIdealState
            icon="error"
            title="You do not have permission to upload files."
          />
        ) : (
          <AddAttachmentsSection {...props} />
        )
      }
    />
  </div>
);

const descriptionSponsor = [
  <p key={shortid.generate()}>
    If you do not see the sponsor you are looking for, contact the Information
    Security Risk and Compliance Department at{' '}
    <a href="mailto:3PA@urmc.rochester.edu">3PA@urmc.rochester.edu</a>.
  </p>,
  <p key={shortid.generate()}>
    The sponsor information should be populated with the department point of
    contact for this Third Party assessment. This point of contact will be
    responsible for responding to any additional follow up questions pertaining
    to this assessment from the Information Security Risk &amp; Compliance
    Department as well as any concerns from the Third Party.
  </p>,
  <p key={shortid.generate()}>
    In situations where a department enters an assessment for a product or
    service on behalf of another area (example: Clinical Engineering purchases a
    device for another department), please select the utilizing department in
    the Requesting Department field. If the requesting department is not
    available, please reach out to the Information Security Risk and Compliance
    Department at{' '}
    <a href="mailto:3PA@urmc.rochester.edu">3PA@urmc.rochester.edu</a>.
  </p>,
];
const description3rdParty = [
  <p key={shortid.generate()}>
    As a sponsor, begin entering in the legal name of the Third Party and, if
    available, select from the dropdown menu. If the Third Party name does not
    populate, type in the name. Repeat this step with the product or service
    being requested and the Third Party contact information.
  </p>,
  <p key={shortid.generate()}>
    Some Third Parties have multiple products or services that they can offer.
    It is possible for a Third Party name to appear but the product or service
    has not yet been reviewed. If the product or service is not available, this
    information can be manually added. Please be as descriptive as possible when
    adding products and services to 3PA. Include such information as product
    name, model number and version, etc.
  </p>,
];
const descriptionDocuments = [
  <p key={shortid.generate()}>
    Please utilize this section to attach additional information that may be
    useful in processing this Third Party assessment. Examples of documents that
    should be attached are:
  </p>,
  <ul key={shortid.generate()}>
    <li>Scope Information</li>
    <li>Purchase Order Requests</li>
    <li>Documentation from the Third Party</li>
  </ul>,
];

export default VendorRequestForm;
